export default class MapeadorVazio {
    processar() {
        // 
    }
}